<template>
  <div>
    <ModalViewSms id="modal-view-sms" :message="selectedSms" />
    <b-row class="mt-4">
      <b-col class="d-inline">
        <p style="max-width: 900px">
          View spam reports created by our messaging providers
        </p>
      </b-col>
    </b-row>
    <b-row class="mb-2">
      <b-col>
        <div class="d-flex flex-row align-items-center">
          <R-Button
            @onClick="retrieveSmsSpamReports"
            class="mr-2 fill-light"
            :isDisabled="showLoader"
          >
            <RefreshIcon style="transform: translateY(-2px)" />
          </R-Button>
          <R-Tooltip
            enableArrow
            :showOn="'click'"
            :orientation="'top'"
            :title="'For data privacy reasons, we do not disclose the body of the message unless you click the SMS cell in the table which will track your action in the audit trail.'"
          >
            <InfoCircleSmallIcon
              size="26"
              class="mr-2 cursor-pointer"
              style="opacity: 0.7"
            />
          </R-Tooltip>
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12" class="mt-2">
        <table-view
          ref="table"
          v-model="getSmsSpamReports"
          :visibleColumns="visibleColumns"
          :columnTitles="columnTitles"
          :formatter-cell="formatterCell"
          :isEditable="false"
          :hasSubmit="false"
          :showLoader="showLoader"
          :hasEditActionButtons="false"
          :hasSetActionButtons="false"
          :hasDownload="true"
          @cellClick="cellClicked"
        >
        </table-view>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import TableView from "@/vue/components/tabulator/Index.vue";
import ModalViewSms from "@/vue/views/tools/smsaudit/ModalViewSms";
import Datepicker from "vuejs-datepicker";
import debounce from "lodash/debounce";
import DateTimeRangeSelector from "@8x8/oxygen-date-time-range-selector";
import InfoCircleSmallIcon from "@8x8/oxygen-icon/icons/InfoCircleSmallIcon";
import { DURATION, notify, TYPE } from "@8x8/oxygen-toaster";
import Button from "@8x8/oxygen-button";
import Tooltip from "@8x8/oxygen-tooltip";

const columns = [
  { name: "sender", label: "Phone Number" },
  { name: "count", label: "Duplicate Count" },
  { name: "messageId", label: "SMS" },
  { name: "errorMessage", label: "Error Message" },
  { name: "customerName", label: "Customer Name" },
  { name: "customerId", label: "Customer Id" },
];

export default {
  name: "SmsSpamReport",
  props: ["title"],
  components: {
    ModalViewSms,
    Datepicker,
    TableView,
    DateTimeRangeSelector,
    InfoCircleSmallIcon,
    RButton: Button,
    RTooltip: Tooltip,
  },
  data() {
    return {
      selectedSms: null,
      showLoader: false,
      columns,
      labelTheme: { fontWeight: 600 },
    };
  },
  computed: {
    getSmsSpamReports() {
      const storeData = this.$store.state.smsaudit.smsSpamReports || [];
      return storeData.map((spamReport) => {
        const columnReorder = {};
        columns.forEach(({ name }) => (columnReorder[name] = spamReport[name]));
        return columnReorder;
      });
    },
    columnTitles() {
      const colTitles = {};
      columns.forEach(({ name, label }) => (colTitles[name] = label));
      console.log(colTitles);
      return colTitles;
    },
    visibleColumns() {
      return columns.map((c) => c.name);
    },
  },
  mounted() {
    if (!this.getSmsSpamReports.length) {
      this.retrieveSmsSpamReports();
    }
  },
  methods: {
    ...mapActions(["fetchSmsSpamReports", "getSmsBody"]),
    retrieveSmsSpamReports: debounce(async function () {
      try {
        this.showLoader = true;
        await this.fetchSmsSpamReports();
      } catch (e) {
        notify({
          content: e.message || e,
          type: TYPE.error,
          duration: DURATION.INFINITE,
        });
        throw e;
      } finally {
        this.showLoader = false;
      }
    }, 1000),
    formatterCell(cell) {
      const key = cell.getField();
      const value = cell.getValue();

      // Hide the body by default and add a button to View that triggers audit trail
      if (key === "messageId" && value) {
        return `<span class="btn-link">View Message</span>`;
      }

      return value;
    },
    async cellClicked(event, cell) {
      if (cell.getField() !== "messageId") return;

      const { messageId, phoneNumber, customerId } = cell.getData();

      try {
        this.showLoader = true;
        this.selectedSms = await this.getSmsBody({
          smsId: messageId,
          phoneNumber,
          customerId,
        });
        this.$bvModal.show("modal-view-sms");
      } catch (e) {
        notify({
          content: e.message || e,
          type: TYPE.error,
          duration: DURATION.INFINITE,
        });
        this.showLoader = false;
        throw e;
      } finally {
        this.showLoader = false;
      }
    },
  },
};
</script>
